import {
	addClass,
	findAll,
	findID,
	find,
	listener,
	removeClass,
} from "../../../../modules/vegas/js/util";
import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGSelect} from "vgselect";
import {VGRollup} from "vgrollup";

const VGListener = {
	onReady: () => {
		VG.plugins.init();
		VG.Scroll.toTop.init();
		VG.Scroll.Header.init();
		VG.Scroll.toElement.init('gta');
		VG.clone();

		// [vegas]
		VG.log();
	},

	onScroll: (event) => {
		VG.Scroll.toTop.init();
		VG.Scroll.Header.init();
		VG.Scroll.toElement.init('gta');
	},

	onResize: (event) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	clone: () => {
		if (window.innerWidth < 699) {
			let $obj_filters_clone = find('.catalog-filters--clone');
			if ($obj_filters_clone) {
				$obj_filters_clone.cloneNode(true);

				let $clonedFilters = find('.catalog-sidebar--clone-filters');
				if ($clonedFilters) {
					$clonedFilters.append($obj_filters_clone);

					let $accItem = [...findAll('.accordion-item', $clonedFilters)];
					if ($accItem.length) {
						$accItem.forEach(function (el, index) {
							if (index === 0) el.remove();
						});
					}
				}
			}
		}
	},

	plugins: {
		init: () => {
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableVGRollup();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false
			});
		},

		enableVGSelect: function ()  {
			let elements = findAll('.vg-select');
			for (const element of elements) {
				new VGSelect(element, {})
			}
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableVGRollup: function () {
			let $rollups = [... document.querySelectorAll('[data-rollup-content]')];
			$rollups.forEach((element) => {
				let target = element.id,
					content = element.dataset.rollupContent || 'text';

				new VGRollup(target, {
					content: content
				});
			});
		},
	},

	Scroll: {
		toTop: {
			position: 400,
			btn: 'btn-scroll-to-top',

			init: function () {
				let $layoutScrollToTop = findID(this.btn);

				if (!$layoutScrollToTop) {
					let div = document.createElement('div');
					addClass(div, 'to-top');
					div.setAttribute('id', this.btn);
					div.innerHTML = '<span><i class="fal fa-chevron-up"></i></span>';

					document.body.append(div);
				}

				this.setPosition();

				listener('click', '#' + this.btn, function () {
					window.scrollTo(0, 0);
				});
			},

			setPosition: function () {
				let $sticky = findID(this.btn);

				if (document.documentElement.scrollTop >= this.position) {
					addClass($sticky, 'is-active')
				} else {
					removeClass($sticky, 'is-active')
				}
			}
		},

		loadMap: {
			isInit: false,
			init: function (map) {
				let $map = findID(map);

				if ($map) {
					let offsetTop = $map.getBoundingClientRect().top,
						windowHeight = window.innerHeight,
						offset = offsetTop - windowHeight;

					if (offset < 100 && !this.isInit) {
						VGMap.init($map, {
							callback: {
								afterInitMap: function (map, params, _this) {
									_this.PlaceMark.set(map, params);
								}
							}
						});

						this.isInit = true;
					}
				}
			}
		},

		Header: {
			lastScrollTop: 0,
			minStartScroll: 200,
			body: document.body,
			stickyArea: [...findAll('.sticky-area')],
			height: {
				window: window.innerHeight
			},

			init: function () {
				let $sticky = find('.header-wrapper'),
					scroll = document.documentElement.scrollTop;

				if ($sticky) {
					if (scroll > 50) {
						addClass($sticky, 'hide');
					}

					if (scroll > this.minStartScroll) {
						addClass(this.body, 'header--is-scroll');
						addClass($sticky,'scroll');

						if (scroll > this.lastScrollTop) {
							removeClass($sticky,'fixed');
							removeClass(this.body,'header--is-fixed');

							if (this.stickyArea.length) {
								this.stickyArea.forEach((sticky) => removeClass(sticky,'fixed'));
							}
						} else {
							addClass($sticky,'fixed');
							addClass(this.body,'header--is-fixed');

							if (this.stickyArea.length) {
								this.stickyArea.forEach((sticky) => addClass(sticky,'fixed'));
							}
						}

						this.lastScrollTop = scroll;
					} else if (scroll === 0) {
						removeClass($sticky, 'scroll fixed hide')
						removeClass(this.body,'header--is-scroll header--is-fixed');
					}
				}
			},
		},

		toElement: {
			init: function (container) {
				let $container = findID(container),
					_this = this;

				if($container) {
					let observer = new IntersectionObserver(function(entries) {
						if(entries[0]['isIntersecting'] === true) {
							if(entries[0]['intersectionRatio'] === 1) {
								addClass($container, 'show');
								observer.unobserve($container);
							}
						}
					}, { threshold: [0, 0.5, 1] });

					observer.observe($container);
				}

				if (window.innerWidth < 668) {
					addClass($container, 'show');
				}
			}
		}
	}
}
export default VGListener;
